const EN_LOCALE_ONLY = process.env.EN_LOCALE_ONLY === 'true'
const IN_BROWSER = typeof window !== 'undefined'
const IS_PROD = process.env.NODE_ENV === 'production'
const IS_DEV = process.env.NODE_ENV === 'development'

module.exports = {
  EN_LOCALE_ONLY,
  IN_BROWSER,
  IS_PROD,
  IS_DEV,
}
